module.exports = __webpack_public_path__ + "static/Panda2-df81303936b1f5b6b0fd9fcc1cdddc36.svg";